<template>
  <div class="card--challenges">
    <div class="card--challenges--text">
      <p>{{ modalChallenge.description }}</p>
    </div>
    <div class="card--challenges-btns">
      <button type="button" class="btn--edit" @click="editChallenge('edit')">
        <img class="img-fluid" src="@/assets/img/btn-edit.png" alt="icon edit" title="icon edit"/>
      </button>
      <button type="button" class="btn--remove" @click="editChallenge('delete')">
        <img class="img-fluid" src="@/assets/img/btn-excluir.png" alt="icon delete" title="icon delete"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props: ['modalChallenge'],
  methods: {
    ...mapActions('Tasks', ['setEditModalChallenge']),
    editChallenge(data) {
      this.setEditModalChallenge({...this.modalChallenge });
      if (data === 'delete') {
        this.$bvModal.show('modal-challenge-delete')
        return;
      }
      this.$bvModal.show('modal-challenge');
    },
  },
}
</script>

<style lang="scss">
.card--challenges {
  padding: 20px 15px 10px 15px;
  background: var(--white);
  border-radius: 15px;
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  margin-bottom: 30px;
  &--text {
    text-align: left;
    p {
      font-size: 14px;
      font-family: 'Font Light';
      color: var(--black);
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 0;
    }
  }
  &-btns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    .btn--edit, .btn--remove {
      background: 0;
      border: 0;
      padding: 0;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.6;
      }
    }
    .btn--edit {
      margin-right: 5px;
    }
  }
}
</style>
